export enum TaxNumberEnum {
  IS_TAX_PAYER = 'isTaxPayer',
  TAX_SUBJECT = 'taxSubject',
  TAX_NUMBER = 'taxNumber',
  TAX_NUMBER_IN_USE = 'TAX_NUMBER_IN_USE',  
}
